import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class DateRangeBannerService {
	private minDate: moment.Moment;
	private bannerStateSubject = new Subject<boolean>();
	public bannerState$ = this.bannerStateSubject.asObservable();

	constructor() {
		this.minDate = moment().subtract(2, 'years').subtract(3, 'months').startOf('day');
	}

	public getMinDate(): moment.Moment {
		return this.minDate.clone();
	}

	public checkDateRangeBanner(dateRange: any): boolean {
		if (dateRange && dateRange.endDate) {
			const endDate = moment(dateRange.endDate);
			const endDateMinusOneYear = endDate.clone().subtract(1, 'year');
			const shouldShowBanner = endDateMinusOneYear.isBefore(this.minDate);
			this.bannerStateSubject.next(shouldShowBanner);
			return shouldShowBanner;
		}
		return false;
	}

	public shouldShowBannerForDateRange(startDate: any, endDate: any): boolean {
		return this.checkDateRangeBanner({ startDate, endDate });
	}
}
